module.exports = "/_next/static/images/fallback_L-3cc32a8979407ca0daf51532d9f68256.png";